import React from "react";
import FormRow from "../FormRow/index.js";
import FormColumn from "../FormColumn/index.js";
export default function FormBlockColumn(props) {
  return /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormColumn, props));
}
FormBlockColumn.defaultProps = {
  xs: true
};